var React = require('react');

function CategoryWonderwomen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.1,3.5c-3.9,0.1-10.9,1.2-10.9,5.6c0-4.5-7-5.6-10.9-5.7C1.3,3.4,0,2.7,0,2.7C0.6,3.1,2.5,9,5.7,12.8    \tc3.2,3.9,7.9,2.2,8.7,1.5c0.8-0.6,1.7-0.6,1.7-0.6s1.1-0.1,1.7,0.6c0.8,0.8,5.6,2.3,8.7-1.5c3.3-3.8,5.3-9.7,5.8-10.1    \tC31.7,2.7,31,3.4,27.1,3.5z M8.4,10.9c-2-1-1.8-3.8-1.8-3.8c5.8-1,6.1,3.6,6.1,3.6S10.8,12.1,8.4,10.9z M23.9,11    \tc-2.4,1.1-4.2-0.2-4.2-0.2s0.3-4.6,6.1-3.6C25.8,7.2,26,10,23.9,11z","fill":"currentColor"}));
}

CategoryWonderwomen.defaultProps = {"width":"32","height":"18","viewBox":"0 0 32 18"};

module.exports = CategoryWonderwomen;

CategoryWonderwomen.default = CategoryWonderwomen;
